export default {
  0: '草稿',
  1: '审批中',
  2: '已同意',
  3: '已拒绝',
  4: '已撤销',
  5: '已禁用',
  6: '已冻结',
  7: '已删除',
};
